import { render, staticRenderFns } from "./PendingForms1.vue?vue&type=template&id=7315f7f4"
import script from "./PendingForms1.vue?vue&type=script&lang=js"
export * from "./PendingForms1.vue?vue&type=script&lang=js"
import style0 from "./PendingForms1.vue?vue&type=style&index=0&id=7315f7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports